export default function DateRangeErrorBanner({
  show,
  message = "End date can't be before start date.",
}) {
  if (!show) return null;
  return (
    <div className="rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm md:text-base text-rose-700">
      {message}
    </div>
  );
}
